/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Location/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Location({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Location",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Location.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z7LeP2': alignSelf,'--mt-2-Z7LeP2': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z7LeP2': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z7LeP2': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z7LeP2': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z7LeP2': opacity,'--w-10-Z7LeP2': typeof width === 'number' ? `${width}px` : width,'--h-11-Z7LeP2': typeof height === 'number' ? `${height}px` : height,'--f-12-Z7LeP2': fill,'--a-7-Z7LeP2': isAnimated ? animation : "none",'--sd-8-Z7LeP2': isAnimated ? strokeDashoffset : 0,'--sd-9-Z7LeP2': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Location.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M22 14.136c0 .592-.64 1.071-1.429 1.071H8.43v1.607c0 .434-.348.825-.882.99-.534.166-1.149.075-1.557-.232l-3.57-2.678c-.245-.183-.402-.432-.418-.71a.805.805 0 01.002-.128.93.93 0 01.292-.574c.058-.056.123-.107.193-.153.251-.165.58-.265.94-.265H20.57c.79 0 1.429.48 1.429 1.072zm-.004-4.209a.93.93 0 01-.292.577 1.272 1.272 0 01-.193.153c-.251.165-.58.264-.94.264H3.43c-.79 0-1.429-.48-1.429-1.07 0-.593.64-1.072 1.429-1.072h12.143V7.172c0-.434.348-.824.881-.99.534-.166 1.149-.074 1.557.232l3.571 2.678c.257.193.402.447.418.71l-.003.125z"
 style={{'--f-12-Z7LeP2': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}